import * as yup from 'yup';

export type EmailReq = {
  id?: number;
  name: string;
  subject: string;
  content: string;
  system_name?: string | null;
  is_active?: boolean | null;
};
export type EmailQuery = {
  page?: number;
  size?: number;
};
export type EmailRes = {
  current_page: number;
  emails: EmailReq[];
  has_next: boolean;
  total: number;
  total_pages: number;
};

export const schemaEmail = yup.object({
  name: yup.string().required('Field Required'),
  subject: yup.string().required('Field Required'),
  content: yup.string().required('Field Required'),
  system_name: yup.string().optional(),
  is_active: yup.boolean().optional(),
});

export type EmailFormData = yup.InferType<typeof schemaEmail>;
